import React from "react";
import { convertTimeToReadable } from "../../helpers";
import { FaPlaneArrival, FaPlaneDeparture } from "react-icons/fa";
import moment from "moment";

const RenderRoute = ({ journey, dataMap }) => {
  const getSegment = (segmentRef) => {
    return dataMap?.paxSegments[segmentRef];
  };
  const segment = journey.paxSegmentRefIds?.map((item) => getSegment(item));

  return (
    <div className="py-2 space-y-3 md:px-4">
      {/* {segment.map((flight, index) => ( */}
      <div
        // key={index}
        className={`flex items-center justify-between ${
          segment.length - 1 === 1
            ? "border-b border-gray-300 py-2 last:border-b-0"
            : "border-none"
        } `}
      >
        <div className="flex flex-col items-start">
          <div className="flex items-center">
            <FaPlaneDeparture className="mr-2 w-5 h-5 text-blue-500" />
            <span className="text-xl font-medium text-gray-900">
              {/* {flight?.dep?.stationCode} */}
              {segment?.[0]?.dep?.stationCode}
            </span>
          </div>
          <span className="text-sm text-gray-600">
            {/* {moment(flight?.dep?.schedDateTime).format(
                "ddd, MMM D : hh:mm A"
              )} */}
            {moment(segment?.[0]?.dep?.schedDateTime).format(
              "ddd, MMM D : hh:mm A"
            )}
          </span>
        </div>

        <div className="flex flex-col items-center">
          <div className="">
            <span>{}</span>
          </div>
          <div className="flex items-center">
            <span className="mr-2 h-[2px] w-10 rounded-full bg-main-700"></span>
            <span className="text-sm text-gray-600">
              {/* {convertTimeToReadable(flight?.duration)} */}
              {convertTimeToReadable(segment?.[0]?.duration)}
            </span>
            <span className="ml-2 h-[2px] w-10 rounded-full bg-main-700"></span>
          </div>
        </div>

        <div className="flex flex-col items-end">
          <div className="flex items-center">
            <FaPlaneArrival className="mr-2 w-5 h-5 text-green-500" />
            <span className="text-xl font-medium text-gray-900">
              {/* {flight?.arrival?.stationCode} */}
              {segment?.at(-1)?.arrival?.stationCode}
            </span>
          </div>
          <span className="text-sm text-gray-600">
            {/* {moment(flight?.arrival?.schedDateTime).format(
                "ddd, MMM D : hh:mm A"
              )} */}
            {moment(segment?.at(-1)?.arrival?.schedDateTime).format(
              "ddd, MMM D : hh:mm A"
            )}
          </span>
        </div>
      </div>
      {/* ))} */}
    </div>
  );
};

export default RenderRoute;
